export const closeVideoModal = (
   { args, onUserAction, additionalData, getState }: any,
   callback: any
) => {
   const { storeValues } = getState();
   const { siNumberStatusDetails } = storeValues ?? {};
   const { actionRequired = 'FULL_KYC' } = siNumberStatusDetails || {};

   const isClosedWithoutUpload = args?.[0] === 'closeWithoutUpload';
   const isNewSKYCJourney = storeValues?.journeyContext?.journey === 'SKYC_NEW';
   let isSuccess;

   if (isNewSKYCJourney) {
      isSuccess = additionalData?.dataFromWidget?.response?.status === '200';
   } else {
      isSuccess = additionalData?.dataFromWidget?.response?.status?.code === '200';
   }
   isSuccess = isSuccess || isClosedWithoutUpload;

   const actions: any[] = [];

   if (isSuccess) {
      callback();
      if (!isClosedWithoutUpload) {
         actions.push({
            type: 'nativeEventEmitter',
            payload: {
               eventName: 'step5Widget',
               eventData: {
                  state: 'success',
                  isExpanded: false,
               },
            },
         });

      if(!isNewSKYCJourney){
         actions.push({
            analyticsAction: 'click',
            analyticsData: {
               eventCategory: 'SKYC_LANDING_PAGE',
               section: 'stepssection',
               subSection: 'step5Widget',
               eventAction: 'pageclose',
               eVar21: '{{storeValues:appData.msisdn}}',
               extraData11: '{{storeValues:layoutContext.layout}}',
               prop8: 'reverification',
               prop7: '{{storeValues:siNumberStatusDetails.customerZone}}',
               prop6: '{{storeValues:siNumberStatusDetails.actionRequired}}',
            }
         })
      }

         if (actionRequired === 'FULL_KYC') {
            actions.push({
               type: 'nativeEventEmitter',
               payload: {
                  eventName: 'step6Widget',
                  eventData: {
                     state: 'none',
                     isExpanded: true,
                  },
               },
            });

            if(isNewSKYCJourney){
               actions.push({
                  payload: {
                     eventData: {
                        state: 'none',
                        isExpanded: true,
                     },
                     eventName: 'DISABILITY_INFO',
                  },
                  type: 'nativeEventEmitter',
               });
               actions?.push({
                  analyticsAction: 'impression',
                  analyticsData: {
                     eventCategory: 'NEW_ACQ_POSTPAID_SKYC',
                     section: 'stepsSection',
                     subSection: 'DISABILITY_INFO',
                     eventAction: 'pageloaded',
                     eventLabel: '',
                     eventValue: '',
                     customValue: '',
                     customLabel: '',
                     prop35: '{{storeValues:orderData.orderData.cartId}}',
                     extraData12: '{{storeValues:orderData.orderData.cartItemId}}',
                     prop45: '{{storeValues:appData.subJourney}}',
                     eVar21: '{{storeValues:appData.loggedInNumber}}',
                     eVar36: '{{storeValues:appData.msisdn}}',
                     city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
                     eVar25: '{{storeValues:pincodeContext.pincodeDetails.circleName}}',
                     prop4: 'SKYC',
                     extraData11: '{{storeValues:layoutContext.layout}}',
                     prop7: '{{storeValues:outstationContext.isOutstation}}',
                     prop9: '{{storeValues:appData.lob}}',
                  },
               });
            }

         } else {
            actions.push({
               payload: {
                  eventData: {
                     leftCta: {
                        buttonType: 'primary',
                        disabled: false,
                        size: "md",
                        title: 'Verify Via OTP & Submit',
                     },
                  },
                  eventName: 'FinalSubmitButton_submitButton'
               },
               type: 'nativeEventEmitter',
            });
         }
      }
   } else {
      if(isNewSKYCJourney) {
         actions.push(
            {
               analyticsAction: 'impression',
               analyticsData: {
                  eventCategory: 'NEW_ACQ_POSTPAID_SKYC',
                  section: 'stepsSection',
                  subSection: 'Step5Widget',
                  eventAction: 'impression',
                  eventLabel: 'submit',
                  eventValue: '',
                  customValue: 'Video cannot be submitted',
                  customLabel: 'button',
                  prop35: '{{storeValues:orderData.orderData.cartId}}',
                  extraData12: '{{storeValues:orderData.orderData.cartItemId}}',
                  prop45: '{{storeValues:appData.subJourney}}',
                  eVar21: '{{storeValues:appData.loggedInNumber}}',
                  eVar36: '{{storeValues:appData.msisdn}}',
                  city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
                  eVar25: '{{storeValues:pincodeContext.pincodeDetails.circleName}}',
                  prop4: 'SKYC',
                  extraData11: '{{storeValues:layoutContext.layout}}',
                  prop7: '{{storeValues:outstationContext.isOutstation}}',
                  prop9: '{{storeValues:appData.lob}}',
                  eVar10: 'error'
               },
            }
         )
      }
      onUserAction({
         actions: [
            {
               type: 'showToast',
               payload: {
                  title: 'something went wrong please try again',
                  dismissDuration: 5000,
                  position: 'bottom-center',
                  state: 'error',
                  style: {
                     zIndex: 10000,
                  },
               },
            },
         ],
      });
   }

   onUserAction({
      actions,
   });
};